import script from "./HorizontalScroll.vue?vue&type=script&lang=ts&setup=true"
export * from "./HorizontalScroll.vue?vue&type=script&lang=ts&setup=true"

import "./HorizontalScroll.vue?vue&type=style&index=0&id=481a6a81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-481a6a81"]])

export default __exports__